import { render, staticRenderFns } from "./MultipleRegister.vue?vue&type=template&id=3a3d4018&"
import script from "./MultipleRegister.vue?vue&type=script&lang=js&"
export * from "./MultipleRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports